<template>
  <div class="Facebook">
    <Header />
    <div class="main">
      <!-- <div class="box"><img src="../assets/Facebook.jpg" alt=""></div> -->
      <div class="box"><img src="../assets/aotuo/3-1.png" alt="" /></div>
    </div>
    <!-- <Sidebar /> -->
    <Footer />
  </div>
</template>
<script>
import Header from '../components/Head'
import Sidebar from '../components/Sidebar.vue'
import Footer from '../components/Footer'

export default {
  name: 'Facebook',
  components: {
    Header,
    Sidebar,
    Footer,
  },
  data() {
    return {
      launage: '',
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  margin: auto;
}
img {
  width: 100%;
  border: 0;
  display: block;
}
</style>
